import { Layout } from 'antd'
import clsx from 'clsx'
import { type FC, type ComponentPropsWithoutRef } from 'react'

const { Content } = Layout

type Props = ComponentPropsWithoutRef<typeof Content>

export const ContentLayout: FC<Props> = ({ children, className, ...props }) => {
  return (
    <Content
      {...props}
      className={clsx([
        // Sider(幅230px)を含む全体の最小幅を1200pxにするため、
        // コンテンツ領域は 1200 - 230 = 970px を下回らないようにする
        //
        // 高さは h-svh で viewport に固定し overflow-auto でこのコンテナ自身を
        // スクロール領域にする。min-h-svh(コンテンツ高まで伸長=window スクロール)だと
        // 一覧テーブルの sticky ヘッダ(position: sticky)がこの overflow 祖先を基準に
        // 貼り付くのにコンテナ自身が伸びて内部スクロールせず、window スクロールで
        // ヘッダごと流れて固定されない(#4313)。コンテナを実スクロール領域にすると
        // sticky ヘッダがコンテナ上端に正しくピン留めされる。
        'h-svh min-w-[970px] overflow-auto',
        className
      ])}
    >
      {children}
    </Content>
  )
}
